/**
 * Regras para reaproveitar o pedido aberto do cliente ao voltar para a loja.
 * Sem isso, cada retorno (ex.: voltar do pagamento) criava um novo código de evento.
 */
export const REUSABLE_ORDER_STATUSES = [
  'Acessou Página',
  'Preencheu o simulador',
  'Acessou Proposta',
  'Proposta Fornecedor',
  'Aguardando Pagamento',
  'Aguardando pagamento',
] as const;

const BLOCKING_PAYMENT = new Set(['paid', 'partially_paid']);

export interface ReusableCandidate {
  id: string;
  event_code?: string | null;
  status?: string | null;
  is_active?: boolean | null;
  status_payments?: string | null;
}

/** Retorna o pedido aberto mais recente que pode ser reaproveitado (lista já ordenada desc). */
export function pickReusableOrder<T extends ReusableCandidate>(rows: T[]): T | undefined {
  return rows.find(
    (r) =>
      r.is_active !== false &&
      r.status !== 'Excluído' &&
      (REUSABLE_ORDER_STATUSES as readonly string[]).includes(String(r.status ?? '')) &&
      !BLOCKING_PAYMENT.has(String(r.status_payments ?? '').toLowerCase()),
  );
}

/** Lê o pedido-alvo guardado na sessão para a promoção da proposta atualizar o mesmo evento. */
export function readTargetEventId(): string | null {
  try {
    const v = sessionStorage.getItem('ameup_parent_event_id');
    return v && /^[0-9a-f-]{36}$/i.test(v) ? v : null;
  } catch {
    return null;
  }
}
